import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchCountriesApi = async () => {
  const response = await axiosInstance.get(`${Endpoints.GET_COUNTRY}`);
  return response.data;
};

export const fetchStatesApi = async (countryId) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_STATE}${countryId}`
  );
  return response.data;
};

export const fetchCurrencyApi = async () => {
  const response = await axiosInstance.get(`${Endpoints.GET_CURRENCY_DETAILS}`);
  return response.data;
};
